<template>
<el-dialog
  :visible='true'
  title='增值服务订购'
  :before-close='handleClose'
  width='600px'
  :close-on-click-modal='false'
>
<div >
  <div>订购服务：{{  item.priceProject }}</div>
  <div style="margin: 10px 0;">
    <el-table
      :data="list"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
      tooltip-effect="light"
      style="
        display: inline-block;
        border: 1px solid #eee;
        vertical-align: top;
        width: 87%;
        position: relative;
      "
    >
      <template slot="empty">
        <div>
          <img src="@/assets/images/default/暂无任何数据.png" />
          <span style="margin-left: -140px">暂无任何数据</span>
        </div>
      </template>
      <el-table-column prop="amount" label="周期">
        <template>
          <span >{{ item.cycle }}天</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="原价(元)">
        <template>
          <span >￥{{ item.originalMoney }}</span>
        </template>
      </el-table-column>  
      <el-table-column label="优惠价(元)">
        <template>
          <span style="color: red">￥{{ item.money }}</span>
        </template>
      </el-table-column>
    </el-table>
</div>
  <div>支付方式：
    <el-radio-group v-model="rechargeManner">
      <el-radio :label="0" >支付宝支付</el-radio>
    </el-radio-group>
  </div>
</div>
<template #footer>
  <div class='dialog-bottom'>
    <el-button @click='handleClose' type='secondary' size='small'>取消</el-button>
    <el-button @click='handleConfirm' type='primary' size='small'>去支付</el-button>
  </div>
</template>
</el-dialog>
</template>

<script>
import {
  alipayPay,
} from "@/api/backstage/smsPay";
export default {
 name: '' ,
 components: {},
 props:{
  visible: {
    type: Boolean,
    default: false,
  },
  item:{
    type: Object,
    default:()=>{
      return {

      }
    },
  }
 },
 data() {
 return {
  rechargeManner:0,
  list:[{}]
 }
 },
 computed: {},
 created() {
 
 },
 mounted() {
 
 },
 methods: {
  handleClose() {
   this.$emit('close');
  },
  handleConfirm() {
    alipayPay({
        count: "1",
        type: "valueAddPack",
        money: this.item.money,
        rechargePacketId:this.item.id,
        priceProject:this.item.priceProject,
        sign:this.item.sign,
        paySmsTotal:'0',
        paySign:4
      }).then((res) => {
        if (res.code == 0) {
          this.$message.error(res.message);
          return;
        } else {
          document.querySelector("body").innerHTML = res;
          const div = document.createElement("div"); // 创建div
          div.innerHTML = res; // 将返回的form 放入div
          document.body.appendChild(div);
          document.forms[0].submit();
        }
      });
  },
 }
}
</script>
<style lang='scss' scoped>

.dialog-bottom {
  text-align: center;
}
</style>